// 불출 이력 팝업
<template>
	<sf-modal-layout size="xl" :title="getMessage_('QWCC001901')" :show="show" :closeModal="close">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 h-100 card_bg">
				<div class="sf-search-layout__body__container">
					<sf-search-layout>
						<el-row :gutter="20">
							<!-- 장비명 -->
							<el-col :span="5">
								<search-input :label="getMessage_('QWCC001314')" :propData="mesEqipNm" :readonly="true"> </search-input>
							</el-col>
							<!-- 불출기간 -->
							<el-col :span="8">
								<div class="sf-input-group-wrapper">
									<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001657') }}</span>
									<el-date-picker
										v-model="searchDateRange"
										type="daterange"
										align="right"
										:start-placeholder="getMessage_('QWCC000920')"
										:end-placeholder="getMessage_('QWCC000954')"
										range-separator="~"
									/>
								</div>
							</el-col>
						</el-row>
						<template slot="button">
							<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
								{{ getButtonMsg_(scrId, 'CR') }}
							</sf-button>
						</template>
					</sf-search-layout>
				</div>
			</sf-card>
		</div>
		<div class="sf-col sf-col-10">
			<sf-card class="p-0 border-0 bg-transparent h-100">
				<sf-data-table
					ref="popupTable"
					:pageUnit="pvoPagingInfo.pageUnit"
					:totalSize="pvoPagingInfo.totalSize"
					paging
					:columns="columns"
					:rows="pvoResultList"
					index
					height="50vh"
					fit="fit"
					:stripe="false"
					:excel="isButton_(scrId, 'EX')"
					@changedPage="changedPage"
				>
				</sf-data-table>
			</sf-card>
		</div>
	</sf-modal-layout>
</template>

<script>
import _ from 'lodash';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesCalPvo/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import SearchInput from '@qms/Components/SearchInput';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput },
	data() {
		return {
			show: false,
			mesEqipNo: '',
			mesEqipNm: '',
			searchDateRange: [this.$moment().startOf('year').format('YYYY-MM-DD'), this.$moment().endOf('year').format('YYYY-MM-DD')]
		};
	},
	async created() {
		await this.getCommCodes_({ key: 'sndStCdList', codeType: 'SND_ST' }); //발송상태;
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open({ mesEqipNo, mesEqipNm }) {
			this.show = true;
			this.searchDateRange = [this.$moment().startOf('year').format('YYYY-MM-DD'), this.$moment().endOf('year').format('YYYY-MM-DD')];
			this.mesEqipNo = mesEqipNo;
			this.mesEqipNm = mesEqipNm;
			this.searchList();
		},
		close() {
			// this.refresh();
			this.show = false;
		},
		refresh() {
			this.setState_({ key: 'pvoResultList', value: [] });
			this.$emit('Refresh');
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				const strDt = this.searchDateRange[0] && this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.searchDateRange[1] && this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				await this.getPvoHisList_({ strDt, endDt, mesEqipNo: this.mesEqipNo });
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},

		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setpvoPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setpvoPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001627'), //불출일자
					prop: 'pvoDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001632'), //인수자
					prop: 'pwtiNm',
					minWidth: '110px'
				},
				{
					label: this.getMessage_('QWCC001633'), //불출자
					prop: 'pvorNm',
					minWidth: '110px'
				},
				{
					label: this.getMessage_('QWCC000906'), //비고
					prop: 'rmk',
					minWidth: '380px'
				}
			];
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.searchDateRange = ['', ''];
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.sf-button.sf-line-default {
	min-width: fit-content;
}
</style>
